import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import SectionTitle from '../../Layout/components/SectionTitle';

const ErrorNotFound = () => (
    <Fragment>
        <Helmet
            bodyAttributes={{
                class: 'page page-error vertical-content-force-height-100'
            }}
        />
        <div className="container">
            <SectionTitle cssClass="mt-0 mb-0 align-items-center" title={<Fragment>Page <span>introuvable !</span></Fragment>} subtitle="La page demandée n'est malheureusement pas disponible." />
        </div>
    </Fragment>
);

export default ErrorNotFound;


// WEBPACK FOOTER //
// ./src/features/Errors/components/ErrorNotFound.js